/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import GlobalSettings from '@/model/global/GlobalSettings'

const entity = {}

const config = {
  load: async function (start, end, lang = 'DE') {
    const res = (await hillo.get('BackendData.php?op=dishStatistic', {
      lang: GlobalSettings.getLang(),
      start,
      end
    })).content

    return res
  },
  printOrSendMail: async function (op, dates, dishCategoryIds, dishCategoryTypeIds, hideAttributeIds) {
    return (await hillo.post('Dishes.php?op=' + op, {
      start: dates[0],
      end: dates[1],
      dishCategoryIds,
      dishCategoryTypeIds,
      hideAttributeIds
    }))
  }

}

export default IKDataEntity.ModelFactory(entity, config)
